export default {
  landing: 'landing',
  start: 'start',
  appeals: 'appeals',
  rad: 'rad',
  fileBDD: 'file-bdd',
  unableToFileBDD: 'unable-to-file-bdd',
  fileClaim: 'file-claim',
  fileClaimEarly: 'file-claim-early',
  disagreeFileClaim: 'disagree-file-claim',
};
